<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center">Orden de Prestador #{{ id }}</h1></div>
    </div>

    @if (error()) {
        <div class="alert alert-danger mt-2 mx-3" role="alert"><small>{{ error() }}</small></div>
    }
    @if (message()) {
        <div class="alert alert-success mt-2 mx-3" role="alert"><small>{{ message() }}</small></div>
    }

    @if (orden(); as o) {
        <div class="row-cols-12 m-2 mt-0">
            <div class="detalle-card mt-2">
                <div class="detalle-section-title">Estado</div>
                <div class="d-flex align-items-center gap-2">
                    <select
                        class="form-select form-select-sm orden-estado-select"
                        [disabled]="guardando()"
                        (change)="onEstadoSeleccionadoChange($any($event.target).value)"
                    >
                        @for (estado of estadosOrdenes(); track estado.id) {
                            <option [value]="estado.id" [selected]="estado.id === o.id_estado_orden">
                                {{ estado.x_descripcion }}
                            </option>
                        }
                    </select>
                    <button
                        type="button"
                        class="btn-guardar-estado"
                        [disabled]="!hayCambiosSinGuardar || guardando()"
                        (click)="guardarEstado()"
                    >
                        @if (guardando()) {
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        } @else {
                            Guardar
                        }
                    </button>
                </div>
            </div>

            <div class="detalle-card mt-3">
                <div class="detalle-section-title">Personas</div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-person"></i> Cliente</span>
                    <a class="detalle-value" [routerLink]="['/perfil-cliente', o.id_cliente]">{{ o.nombreCliente || 'Sin nombre' }}</a>
                </div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-person-badge"></i> Prestador</span>
                    <a class="detalle-value" [routerLink]="['/perfil-prestador', o.id_prestador]">{{ o.nombrePrestador || 'Sin nombre' }}</a>
                </div>
            </div>

            <div class="detalle-card mt-3">
                <div class="detalle-section-title">Prestación</div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-clipboard"></i> Especialidad</span>
                    <span class="detalle-value">{{ o.nombreEspecialidad || '-' }}</span>
                </div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-clipboard2-pulse"></i> Prestación</span>
                    <span class="detalle-value">{{ o.nombrePrestacion || '-' }}</span>
                </div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-geo-alt"></i> Zona</span>
                    <span class="detalle-value">{{ o.x_zona || 'A confirmar' }}</span>
                </div>
                @if (o.x_img_receta) {
                    <div class="detalle-row">
                        <span class="detalle-label"><i class="bi bi-file-earmark-text"></i> Receta</span>
                        <a class="detalle-value" style="cursor:pointer;" (click)="openReceta()">Ver imagen</a>
                    </div>
                }
            </div>

            <div class="detalle-card mt-3">
                <div class="detalle-section-title">Fechas propuestas por el cliente</div>
                <div class="detalle-row"><span class="detalle-label">Opción 1</span><span class="detalle-value">{{ o.d_fecha_uno ? (o.d_fecha_uno | date:'dd/MM/yyyy HH:mm') + 'hs' : '-' }}</span></div>
                <div class="detalle-row"><span class="detalle-label">Opción 2</span><span class="detalle-value">{{ o.d_fecha_dos ? (o.d_fecha_dos | date:'dd/MM/yyyy HH:mm') + 'hs' : '-' }}</span></div>
                <div class="detalle-row"><span class="detalle-label">Opción 3</span><span class="detalle-value">{{ o.d_fecha_tres ? (o.d_fecha_tres | date:'dd/MM/yyyy HH:mm') + 'hs' : '-' }}</span></div>
            </div>

            @if (o.d_fecha_uno_prestador || o.d_fecha_dos_prestador || o.d_fecha_tres_prestador) {
                <div class="detalle-card mt-3">
                    <div class="detalle-section-title">Fechas propuestas por el prestador</div>
                    <div class="detalle-row"><span class="detalle-label">Opción 1</span><span class="detalle-value">{{ o.d_fecha_uno_prestador ? (o.d_fecha_uno_prestador | date:'dd/MM/yyyy HH:mm') + 'hs' : '-' }}</span></div>
                    <div class="detalle-row"><span class="detalle-label">Opción 2</span><span class="detalle-value">{{ o.d_fecha_dos_prestador ? (o.d_fecha_dos_prestador | date:'dd/MM/yyyy HH:mm') + 'hs' : '-' }}</span></div>
                    <div class="detalle-row"><span class="detalle-label">Opción 3</span><span class="detalle-value">{{ o.d_fecha_tres_prestador ? (o.d_fecha_tres_prestador | date:'dd/MM/yyyy HH:mm') + 'hs' : '-' }}</span></div>
                </div>
            }

            <div class="detalle-card mt-3">
                <div class="detalle-section-title">Turno confirmado</div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-calendar2-check"></i> Fecha y hora</span>
                    <span class="detalle-value">{{ o.d_fecha_turno ? (o.d_fecha_turno | date:'dd/MM/yyyy HH:mm') + 'hs' : 'A confirmar' }}</span>
                </div>
            </div>

            <div class="detalle-card mt-3">
                <div class="detalle-section-title">Pago</div>
                <div class="detalle-row">
                    <span class="detalle-label">Estado del pago</span>
                    <span class="detalle-value">{{ textoPago }}</span>
                </div>
                <div class="detalle-row">
                    <span class="detalle-label">Precio del turno</span>
                    <span class="detalle-value">{{ o.n_precio_turno ? (o.n_precio_turno | currency:'ARS') : 'A confirmar' }}</span>
                </div>
            </div>

            @if (o.x_notas) {
                <div class="detalle-card mt-3">
                    <div class="detalle-section-title">Notas</div>
                    <div class="detalle-notas">{{ o.x_notas }}</div>
                </div>
            }

            <div class="detalle-card mt-3 mb-4">
                <div class="detalle-section-title">Fechas de la orden</div>
                <div class="detalle-row"><span class="detalle-label">Creada</span><span class="detalle-value">{{ o.d_date_create ? (o.d_date_create | date:'dd/MM/yyyy HH:mm') : '-' }}</span></div>
                <div class="detalle-row"><span class="detalle-label">Última actualización</span><span class="detalle-value">{{ o.d_date_updated ? (o.d_date_updated | date:'dd/MM/yyyy HH:mm') : '-' }}</span></div>
            </div>
        </div>
    }
</div>
